var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Recognition = function Recognition(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M17.702 16.5V20.3C17.702 21 17.402 21.7 16.902 22.1C16.402 22.6 15.802 22.9 15.102 22.9C13.702 22.9 12.502 21.7 12.502 20.3V18.7C14.502 18.6 16.302 17.8 17.702 16.5Z"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M11.5018 18.7V20.3C11.5018 21 11.2018 21.7 10.7018 22.1C10.2018 22.6 9.60176 22.9 8.90176 22.9C7.50176 22.9 6.30176 21.7 6.30176 20.3V16.5C7.70176 17.8 9.50176 18.6 11.5018 18.7Z"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      opacity: "0.4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.202 15.9C19.502 14.5 20.302 12.5 20.302 10.4C20.302 5.8 16.602 2 11.902 2C7.20195 2 3.50195 5.8 3.50195 10.4C3.50195 12.5 4.30195 14.5 5.80195 15.9C5.90195 16.1 6.10195 16.3 6.30195 16.5C7.70195 17.7 9.50195 18.6 11.502 18.7H11.702H12.002H12.302H12.502C14.502 18.6 16.302 17.8 17.702 16.5C17.802 16.3 18.002 16.1 18.202 15.9ZM9.20195 14.6008L11.902 13.2008L14.602 14.6008L14.102 11.6008L16.302 9.40078L13.302 9.00078L11.902 6.30078L10.502 9.00078L7.50195 9.40078L9.70195 11.6008L9.20195 14.6008Z"
    }))]
  });
};
export default Recognition;